let quizAnswers = [];

// If clicking to the next slide and it's the last slide, focus on the .next-step button
function isHidden(el) {
    return (el.offsetParent === null)
}

// indexofMax returns the INDEX position of the largest number a provided array.
// used to get beer result in quiz
function indexOfMax(arr) {
    let isTie = false;
    if (arr.length === 0) {
        return -1;
    }
    var max = arr[0];
    var maxIndex = 0;
    // first loop finds the index with largest value in it
    for (var i = 1; i < arr.length; i++) {
        if (arr[i] > max) {
            maxIndex = i;
            max = arr[i];
        }
    }
    // second loop compares the largest against all other indexes
    // and finds if there are any equal/ties, retuns bool if so
    for (var i = 0; i < arr.length; i++) {
        if(i != maxIndex) {
            if (arr[i] == max) {
                // tie true
                isTie = true;
            }
        }
    }

    // handle return
    if(isTie === true) {
        return 'tie';
    } else {
        return maxIndex;
    }
}

// DisplayBeerResult
function displayBeerResult(ansArr) {
    // Elements to replace in results screen
    const replaceElems = {
        "title"         : document.getElementById('bq_result_title'),
        "headline"      : document.getElementById('bq_result_headline'),
        "link"          : document.getElementById('bq_result_link'),
        "linkTitle"     : document.getElementById('bq_result_display_title'),
        "imgWrapper"    : document.getElementById('bq_result_img_url')
    };

    // get possible outcome results
    const quizResultsMap = require('./beer-quiz-results-map.json');

    //
    var quizResults =[];
    quizResults = [0, 0, 0]; // quizResults = [result1, result2, result3]

    // loop through the answers array, and tally up the results. Add to the switch for more options
    for(let q = 0; q < ansArr.length; q++) {
        let answer = ansArr[q].toString();
        switch (answer) {
            case '1':
                quizResults[1]++;
            break;
            case '2':
                quizResults[2]++;
            break;
            case '3':
                quizResults[0]++;
            break;
            default:
            quizResults[0]++;
        }
    }

    var quizResultIndex;
    quizResultIndex = indexOfMax(quizResults);
    if(quizResultIndex === 'tie') {
        quizResultIndex = parseInt(ansArr[0]);
    } else if(quizResultIndex < 0) {
        quizResultIndex = 0;
    }

    // replace fields
    replaceElems.imgWrapper.src      = quizResultsMap[quizResultIndex].imgUrl;
    replaceElems.title.innerHTML     = quizResultsMap[quizResultIndex].title;
    replaceElems.headline.innerHTML  = quizResultsMap[quizResultIndex].summary;
    replaceElems.link.href           = quizResultsMap[quizResultIndex].url;
    replaceElems.linkTitle.innerHTML = quizResultsMap[quizResultIndex].title.toUpperCase();

    // check length of result title, and change class accordingly
    let titleLength = quizResultsMap[quizResultIndex].title.length;
    if(titleLength > 15){
        replaceElems.title.classList.add('small');
    }
}


// Change between the introduction, questions (slides), and result steps.
function animateQuizStep(element, nextStep){
    if(nextStep == null && element.nextElementSibling == 'undefined'){
        return;
    }
    else if(nextStep == null){
        nextStep = element.nextElementSibling;
    }
    element.classList.add('animating-out');

    setTimeout(function(){
        element.classList.add('hide');
        element.classList.remove('in-viewport');

        // If the next step is the quiz itself, navigate to the first slide and set the first slide to have the in-viewport class
        if(nextStep.classList.contains('quiz-step-2')){
            nextStep.classList.add('active');
            nextStep.classList.remove('hide');
            $('.quiz-slider').slick('slickGoTo', 0, true);
        } else if(nextStep.classList.contains('quiz-step-3')){

            quizAnswers[3] = $('.quiz-slider .slick-active .slide').find('.selected-option').data('rel');

            nextStep.classList.add('active');
            nextStep.classList.add('loading');
            setTimeout(function(){
                nextStep.classList.remove('loading');
                nextStep.classList.add('in-viewport');
                displayBeerResult(quizAnswers);
            }, 3000);
        } else {
            nextStep.classList.add('active');
        }
        nextStep.classList.remove('hide');

    }, 400);

    // Prevent elements from previous slide appearing as a flicker
    setTimeout(function(){
        element.classList.remove('animating-out');
        element.classList.remove('active');
    }, 800);
}


// init function call
function initBeerQuiz() {
    let stepOne = document.querySelector('.quiz-step-1');
    let activeStep = document.querySelector('.quiz-step.active');

    activeStep.classList.remove('active');
    activeStep.classList.remove('in-viewport');
    activeStep.classList.add('hide');
    stepOne.classList.add('active');
    stepOne.classList.add('in-viewport');
    stepOne.classList.remove('hide');

    let stepLinks = document.querySelectorAll('.quiz-steps-wrap a.next-step');
    for(let i = 0; i < stepLinks.length; i++) {
        let el = stepLinks[i];
        el.addEventListener('click', function(e){
            e.preventDefault();
            const step = el.closest('.quiz-step');
            animateQuizStep(step);
        });
    };

    let restartLink = document.querySelector('.quiz-steps-wrap .restart-quiz');
    restartLink.addEventListener('click', function(e){
        e.preventDefault();
        quizAnswers = null;
        quizAnswers = [];
        const step = restartLink.closest('.quiz-step');
        const quizStep = step.parentNode.querySelector('.quiz-step-2');
        animateQuizStep(step, quizStep);
    });

    // Change the class of the slider wrap if the options are visible
    let optionsLink = document.querySelectorAll('.quiz-slider .string-select');

    const changeOptionsClass = function(){
        const el = this;

        // make sure class changes have occured.
        setTimeout(function(){
            if(el.closest('.string-select').classList.contains('options-visible')){
                el.closest('.quiz-slider-wrap').classList.add('options-open');
            } else {
                el.closest('.quiz-slider-wrap').classList.remove('options-open');
            }
        },20);
    }

    for(let i = 0; i < optionsLink.length; i++) {
        let el = optionsLink[i];
        el.addEventListener('click', changeOptionsClass);
        el.addEventListener('keypress', changeOptionsClass);
    };

    // Set up tabbing
    // Remove visiblity on inactive slides so that tabbing doesn't include those links.
    const tabIndexLinks = document.querySelectorAll('.quiz-slider .slick-slide');
    for(let i = 0; i < tabIndexLinks.length; i++) {
        let el = tabIndexLinks[i];
        el.style.visibility = 'hidden';
        const links = el.querySelectorAll('a');
        for(let i = 0; i < links.length; i++) {
            let el = links[i];
            el.style.visibility = 'hidden';
        };
    };

    // Set focus on the active option in the pop-up when it opens up
    let tabbingLinks = document.querySelectorAll('.quiz-slider .string-select .selected-option, .quiz-slider .string-select .select-nav');
    for(let i = 0; i < tabbingLinks.length; i++) {
        let el = tabbingLinks[i];
        el.addEventListener('keydown', function(e){
            if(e.which == 13) {
                // wait for it to appear so it can take focus
                setTimeout(function(){
                    let option = el.closest('.string-select').querySelector('.options .active a');
                    if(option == null || option == 'undefined'){
                        option = el.closest('.string-select').querySelector('.options li a');
                    }

                    option.focus();
                }, 100);
            }
        });
    };

    // After selecting the new option, set the next slide or next section link to focus
    tabbingLinks = document.querySelectorAll('.quiz-slider .string-select .options li a');
    for(let i = 0; i < tabbingLinks.length; i++) {
        let el = tabbingLinks[i];
        el.addEventListener('keydown', function(e){
            if(e.which == 13){
                // don't fire this until it has set the new option and the buttons have appeared correctly
                setTimeout(function(){
                    let nextButton;
                    if(el.closest('.slick-slide').nextElementSibling == 'undefined'){
                        nextButton = document.querySelector('.quiz-slider-nav .next-step');
                    } else {
                        nextButton = document.querySelector('.quiz-slider-nav .next');
                    }

                    nextButton.focus();
                }, 30);
            }
        });
    };

    // For restarting the quiz
    tabbingLinks = document.querySelector('.quiz-step .restart-quiz');
    tabbingLinks.addEventListener('keydown', function(e){
        if(e.which == 13){
            // Wait for the transition
            setTimeout(function(){
                document.querySelector('.quiz-slider-nav .next').focus();
            }, 1000);
        }
    });

    tabbingLinks = document.querySelector('.quiz-slider-nav .next');
    tabbingLinks.addEventListener('keydown', function(e){
        const nextButton = document.querySelector('.quiz-slider-nav .next-step');
        setTimeout(function(){
            if(!isHidden(nextButton)){
                nextButton.focus();
            }
        }, 30);
    });
}
var ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
}

ready(() => {
    if(document.querySelector('.quiz-slider')) {
        $('body').on('click', '[modal-target="beerQuizModal"]', function(){
            // Beer quiz slider

            var beerQuizModal = $('#beerQuizModal');
            var quizSlider = $('.quiz-slider');
            var quizSliderWrap = $(quizSlider).parent('.quiz-slider-wrap');
            var quizSlideCount = $(quizSlider).find('.slide').length;

            // Only initialize the slider once
            if(!$(beerQuizModal).hasClass('slider-initialized')){
                quizSlider.slick({
                   slidesToShow: 1,
                   slidesToScroll: 1,
                   adaptiveHeight:true,
                   autoplay: false,
                   dots:false,
                   touchMove: false,
                   swipe: false,
                   infinite: false,
                   accessibility: false,
                   appendArrows: '.quiz-slider-nav',
                   nextArrow: '<a class="btn__theme__lrg next" href="#" title="Click here to view the next question">NEXT</a>',
                   prevArrow: '<a href="#" title="Click here to view the previous question" class="btn__theme__underline reverse prev">Previous</a>'
                });
                $(quizSlider).slick('slickGoTo', 0, true);
                $(beerQuizModal).addClass('slider-initialized');
            };

            quizSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
               $('.quiz-slider .slick-slide').not('.slick-current').find('.slide.in-viewport').removeClass('in-viewport');

               var currentSlide = $(quizSlider).find('.slick-slide').eq(currentSlide);

               $(quizSlider).find('.slick-slide').not(currentSlide).css({'visibility': 'hidden'}).find('a').css({'visibility': 'hidden'});
            });

            quizSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
               // check which slide we're on, to display the correct buttons
               quizAnswers[currentSlide] = $('.quiz-slider .slide').eq(currentSlide).find('.selected-option').attr('data-rel');
               if(quizSlideCount == nextSlide + 1) {
                   $(quizSliderWrap).addClass('last-slide-active');
               } else {
                   $(quizSliderWrap).removeClass('last-slide-active');
               }
               if(nextSlide === 0){
                   $(quizSliderWrap).addClass('first-slide-active');
               } else {
                   $(quizSliderWrap).removeClass('first-slide-active');
               }

               // Change active class for slide numbers
               $(quizSlider).find('.slick-dots li.slick-active').removeClass('slick-active');
               $(quizSlider).find('.slick-dots li').eq(nextSlide).addClass('slick-active');

               // Add class to new slide to animate content
               var newSlide = $('.quiz-slider .slide').eq(nextSlide);

               $(newSlide).addClass('in-viewport');
               $(newSlide).closest('.slick-slide').css({'visibility': ''}).find('a').css({'visibility': ''});
            });

            // Add leading zeros to slide numbers
            function quizSliderCount() {
                if(!$(quizSlider).find('.slick-dots').length){
                    $(quizSlider).append('<ul class="slick-dots headline-dots"></ul>');
                    $(quizSlider).find('.slick-slide').each(function(index){
                        index++;
                        var displayText = index.toString();
                        var chars = displayText.length;
                        if(chars < 2){
                            displayText = '0'+displayText;
                        }

                        $(quizSlider).find('.slick-dots').append('<li><span>'+displayText+'</span></li>');
                    });

                    $(quizSlider).find('.slick-dots button').each(function(){
                        var text = $(this).text();
                        var chars = text.length;
                        if(chars < 2){
                            $(this).text('0'+text);
                        }
                    });
                }
            }
            quizSliderCount();

            // update slider height on option select
            $('body').on('click', '.quiz-slider .animated-select-wrap .string-option', function(e){
               setTimeout(function(){
                   $(window).trigger('resize');
                   $(quizSlider).slick('setPosition');
               }, 10);
            });

            initBeerQuiz();
        });
    }
});
